<template>
  <section class="symbol-legend">
    <div
      class="legend-item"
      v-for="(legendItem, index) in legendData"
      :key="index"
    >
      <img :src="legendItem.url" />
      <span>{{ legendItem.value }}</span>
    </div>
  </section>
</template>

<script>
export default {
  name: 'SymbolLegend',
  props: {
    correct: Array,
    legendData: Array
  }
}
</script>

<style scoped>
.symbol-legend {
  width: 100%;
  display: flex;
  flex-direction: row;
}
.legend-item {
  flex: 1 1 0px;
  display: flex;
  flex-direction: column;
  flex-basis: auto;
  align-items: center;
  font-size: 2rem;
}
.legend-item > img {
  height: 70px;
}
.legend-item:not(:last-child) {
  border-right: 1px solid rgba(0, 0, 0, 0.2);
}
</style>
